<!--卡片简单版 -->
<template>
  <div class="zlr-card-simple"
       :class="{'zlr-cover':circleSign==='green'}">
    <!-- orange green -->
    <div :class="['zlr-card-simple-circle', circleSign]">
      <div></div>
    </div>
    <h2>{{ title }}</h2>
    <div class="zlr-card-simple-avator">
      <img :src="avatar"
           alt="头像">
      <p v-html="con">{{con}}</p>
    </div>
    <div class="zlr-card-simple-link">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// less
import './card-simple.less'
export default {
  name: 'zlr-card-simples',
  props: {
    title: {
      type: [String],
      required: true
    },
    avatar: {
      type: [String],
      default: ''
    },
    circleSign: {
      type: [String],
      default: ''
    },
    // imgSrc: {
    //   type: [String],
    //   required: true
    // },
    con: {
      type: [String],
      required: true
    }
  },
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
